export default {
  init() {
    // JavaScript to be fired on app store page
    // the page <body> should have 'app-store' class
    $(function () {
      var responsiveNavDropdown = function () {

        $('.category-filters .dropdown-toggle').addClass('disabled');
        // On mobile
        if ($(window).width() < 998) {
          $('.category-filters .dropdown-toggle').removeClass('disabled');

          $('.category-filters .dropdown-menu .dropdown-item').on('click', function () {
            $('.dropdown-toggle .dropdown-label').text($(this).text());
            $('.dropdown-toggle .dropdown-label').val($(this).text());
            $('.dropdown-toggle .dropdown-label').css('font-size', '16px');
          });
        }
      };
      $(window).on('load resize', responsiveNavDropdown);
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/appStore.js